/* eslint-env browser */
import React from 'react';
import { toast } from 'react-toastify';
import * as types from '../constants/ActionTypes';

export function loadingDecrement(dispatch) {
  dispatch({ type: types.LOADING_DECREMENT});
}
export function loadingIncrement(dispatch) {
    dispatch({ type: types.LOADING_INCREMENT});
}

export function setProperty(dispatch, propType) {
  dispatch({ type: propType });
}

export function requestStarted(dispatch, actionType) {
  dispatch({ type: actionType });
}

export function updateState(dispatch, actionType, data, cb = () =>{}) {
  dispatch({ type: actionType, payload: data }, cb);
}

export function requestErrored(dispatch, errorObj, actionType) {
  dispatch({ type: types.CALL_FAILED, payload: errorObj, call: actionType });
  if (errorObj && errorObj.response && errorObj.response.statusText === 'Unauthorized') {
    dispatch({ type: types.LOGOUT});
  } else if (errorObj && errorObj.response && errorObj.response.status >= 500) {
    toast.error("System Error", { position: toast.POSITION.TOP_RIGHT });
  } else if (errorObj && errorObj.response && typeof errorObj.response.data) {
    const uiError = <div>{'Error: '}{errorObj.response.data.error}{<br />}{'Unique Id: '}{errorObj.response.data.uniqueId}</div>;
    toast.error(uiError, { position: toast.POSITION.TOP_RIGHT });
  }
  else if (errorObj && errorObj.response && errorObj.response.statusText) {
    toast.error(errorObj.response.statusText, { position: toast.POSITION.TOP_RIGHT });
  } else if (errorObj && errorObj.message) {
    toast.error("System Error", { position: toast.POSITION.TOP_RIGHT });
  }
}

export function requestUnauthorized(dispatch, errorObj) {
  dispatch({ type: types.UN_AUTHORIZED, payload: errorObj });
  dispatch({ type: types.LOGOUT });
}

export function loginFailed(dispatch, errorObj) {
  dispatch({ type: types.UN_AUTHORIZED, payload: errorObj });

  if (errorObj && errorObj.response && errorObj.response.statusText === 'Unauthorized') {
    toast.error(errorObj.response.data, { position: toast.POSITION.TOP_RIGHT });
  }
}